import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 全局样式
import '@/assets/global.css';

//导入图标样式
import '@/assets/fonts/iconfont.css';

// element自带样式
import 'element-ui/lib/theme-chalk/index.css';

// 按需导入element组件
import mElement from '@/plugins/mElement.js';
Vue.use(mElement);

// 引入自定义的axios
import { http, instance, $request } from '@/plugins/axios.js';
Vue.prototype.$http = http;
Vue.prototype.$request = $request;
import { renderHeader } from '@/plugins/renderHeader.js';
Vue.prototype.renderHeader = renderHeader;

import config from '@/config.js';

// 引入打印插件
import print from '@/plugins/print';
Vue.use(print);
// let adminToken=null
window.addEventListener('message', (event) => {
  if(event.data.type=="inject-styles"){
    sessionStorage.setItem('data', JSON.stringify(event.data));
  }
  // if (event.data.type === 'inject-styles') {
  //   const style = document.createElement('style');
  //   style.textContent = event.data.styles;
  //   document.head.appendChild(style);
  // }
});
// import VueRouter from 'vue-router';

// 解决同一页面产生导航冗余，vue-router报错问题

// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)

// }
// import AMap from 'vue-amap'

// Vue.use(AMap)
// // 加载
// AMap.initAMapApiLoader({
//   // 高德的key
//   key: '88edd4eddc7608598d7872a5d9e0b096',
//   // 插件集合
//   plugin: ['AMapManager', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'Geocoder', 'Geolocation', 'AMap.MarkerClusterer', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool', 'AMap.Driving', 'AMap.CitySearch', 'AMap.InfoWindow', 'AMap.LngLat', 'AMap.DistrictSearch', 'AMap.TileLayer.Traffic', 'AMap.Heatmap', 'AMap.Autocomplete', 'AMap.PlaceSearch'],
//   uiVersion: '1.0.11', 
//   // 高德 sdk 版本，默认为 1.4.4
//   v: '1.4.4'
// })
Vue.prototype.$bigScreenApiBase = config.bigScreenApiBase;
let loding = null;
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    if (
      config.url != '/api/Reader/GetReader' &&
      config.url != 'home/statistics/mapdisplay'
    ) {
      loding = Vue.prototype.$loading.service({
        lock: true,
        text: '数据请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    }
    if (config.url == '/driver/epidemicprevention/exportlistdetails') {
      config.responseType = 'arraybuffer';
    }
    if (
      config.url === '/captcha.jpg' ||
      config.url === '/sys/login' ||
      config.url === '/driver/dispatchtruck/dispatchTruckinfoById'||
      config.url === '/sso/login'
    )
      return config;
    else {
      config.headers['token'] = JSON.parse(
        decodeURIComponent(window.sessionStorage.getItem('user'))
      ).token;
      return config;
    }
  },
  function (error) {
    // 对请求错误做些什么
    if (loding) {
      loding.close();
    }
    return Promise.reject(error);
  }
);

// 添加响应拦截
instance.interceptors.response.use(
  response => {
    
    if (loding) {
      loding.close();
    }
    if (response.config.url == '/sys/user/test') {
      return response
    }
    if (!response.data) throw new Error('响应异常');
    switch (response.data.code) {
      case 401:
        returnlogin();
        break;
      default:
        return response;
    }
  },
  function (error) {
    // 对响应错误做点什么
    if (loding) {
      loding.close();
    }
    return Promise.reject(error);
  }
);
let num = 0;
function returnlogin() {
  if (num) return '';
  Vue.prototype.$messageBox
    .confirm('登录过期', '提示', {
      confirmButtonText: '确定',
      showClose: false,
      showCancelButton: false,
      type: 'error',
    })
    .then(_ => {
      // if(!adminToken){
        router.replace('/login');
      // }else{
      //   console.log('登录过期--tiaozhuanback');
      //   router.replace({path:'/login-back',query:{istoken:'true'}});
      //   // router.replace('/login');
      // }
      
    });
  num++;
}

// 添加路由导航全局守卫
router.beforeEach((to, from, next) => {
  document.title = '新能智运平台运营端';
  if (
    to.path === '/login' ||
    to.name === 'pageinfoonly' ||
    to.name === 'paypageonly' ||
    to.name == 'notfound' ||
    to.name == 'data'||
    to.path === "/login-back"
  ) {
    next();
  } else {
    var obj = JSON.parse(
      decodeURIComponent(window.sessionStorage.getItem('user'))
    );

    if (!obj || !obj.token) {
      sessionStorage.removeItem('titleListNew');
      if(!adminToken){
        return next('/login');
      }else{
        return next('/login-back');
      }
      
    }
    
    next();
  }
});

Vue.filter('formatMsgFun', val => {
  if (val) return val;
  return '';
});

Vue.mixin({
  methods: {
    mydateFormat(obj, val = '时分秒') {
      if (!obj) return '';
      let dt = new Date(obj),
        yy = dt.getFullYear(),
        mon = (dt.getMonth() + 1 + '').padStart(2, 0),
        dd = (dt.getDate() + '').padStart(2, 0),
        hh = (dt.getHours() + '').padStart(2, 0),
        min = (dt.getMinutes() + '').padStart(2, 0),
        ss = (dt.getSeconds() + '').padStart(2, 0);
      if (val == '年月日') return `${yy}-${mon}-${dd}`;
      if (val == '时分秒') return `${yy}-${mon}-${dd} ${hh}:${min}:${ss}`;
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
